// Boundary validation for pasted text. Kept as a pure function so it is unit
// testable and reusable by both the UI and future callers.

export const MIN_CHARS = 20;
export const MAX_CHARS = 20_000;

export type FieldErrors = {
  resume?: string;
  job?: string;
};

function validateField(label: string, value: string): string | undefined {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return `${label} is required.`;
  }
  if (trimmed.length < MIN_CHARS) {
    return `${label} is too short — add at least ${MIN_CHARS} characters so there is something to match against.`;
  }
  if (trimmed.length > MAX_CHARS) {
    return `${label} is too long — keep it under ${MAX_CHARS.toLocaleString()} characters.`;
  }
  return undefined;
}

export function validateInputs(resume: string, job: string): FieldErrors {
  const errors: FieldErrors = {};
  const resumeError = validateField('Resume text', resume);
  if (resumeError) errors.resume = resumeError;
  const jobError = validateField('Job description', job);
  if (jobError) errors.job = jobError;
  return errors;
}

export function hasErrors(errors: FieldErrors): boolean {
  return errors.resume !== undefined || errors.job !== undefined;
}
